const notificationPanel = {
  namespaced: true,
  state: {
    showPanel: true,
    showNotificationBubble: false,
    notificationDetails: "",
    showActionConfirmation: false,
    actionConfirmationMessage: "",
    notificationList: [],
  },
  getters: {
    notificationList(state) {
      return state.notificationList;
    },
  },
  actions: {
    togglePanel: ({ commit }) => {
      commit("TOGGLE_SHOW_PANEL");
    },
    popNotification: async ({ commit, dispatch, rootState }, payload) => {
      commit("POP_NOTIFICATION", payload);

      if (payload.shown) {
        if (payload.data.type == "message_alert") {
          if (rootState.conversation.conversationId) {
            dispatch("conversation/loadConversation", rootState.conversation.conversationId, { root: true });
          }

          dispatch("conversation/getGenericConversationsList", null, { root: true });
        }

        /* Put a red dot above Order History as well if an order went through */
        if (payload.data.type == "order_placed_alert") {
          dispatch("orders/allowUpdateOrderList", true, { root: true });

          if (rootState.login.userLoggedIn.category === "seller")
            dispatch("sellerOffers/getAllOffersForUser", null, { root: true });
        }
      }
    },
    displayActionConfirmation: ({ commit }, payload) => {
      commit("DISPLAY_ACTION_CONFIRMATION", payload);
    },
    getNotifications: async ({ commit, rootState }) => {
      const response = await rootState.axios.get("/api/getNotifications");
      if (response.data.success) {
        commit("GET_NOTIFICATIONS", response.data);
      }
    },
    /* ACTION TO HANDLE NOTIFICATION POST */
    sendNotification: async ({ rootState }, payload) => {
      const notificationPayload = {
        platform: "OLFUK", //placeholder
        type_id: payload.type_id,
        from_id: rootState.login.userLoggedIn.userId, // message is from the logged in user
        recipient_id: "", //placeholder until loop participant array
        group_id: payload.group_id,
        content: payload.content,
      };

      if (payload.meta)
        // populate meta if it exists
        notificationPayload.meta = payload.meta;

      if (payload.participants.length > 0) {
        for (let i = 0; payload.participants.length > i; i++) {
          if (
            payload.type_id !== "MESSAGE" ||
            (payload.type_id === "MESSAGE" && payload.participants[i].id !== rootState.login.userLoggedIn.userId)
          ) {
            // Only continue if the recipient is NOT the sender
            notificationPayload.recipient_id = payload.participants[i].id;
            await rootState.axios.post("/api/sendNotification", notificationPayload);
          }
        }
      }
    },
    updateNotification: async ({ dispatch, rootState }, payload) => {
      const notificationPayload = { group_id: payload, user_id: rootState.login.userLoggedIn.userId };
      const response = await rootState.axios.put("/api/updateNotification", notificationPayload);
      if (response.data.success) dispatch("getNotifications");
    },
    sendAdminAlert: async ({ rootState }, payload) => {
      const { type, dto } = payload;

      if (type === "deleteRequest") {
        const body = {
          alertType: type,
          deleteRequest: dto,
        };

        try {
          const alertRes = await rootState.axios.post(`/api/sendAdminAlert`, body);
          return alertRes;
        } catch (ex) {
          return ex;
        }
      } else {
        throw "not supported";
      }
    },
  },
  mutations: {
    TOGGLE_SHOW_PANEL: (state) => {
      state.showPanel = !state.showPanel;
    },
    POP_NOTIFICATION: (state, payload) => {
      state.showNotificationBubble = payload.shown;

      if (payload.shown) {
        state.notificationDetails = payload.data;
      } else {
        state.notificationDetails = "";
      }
    },
    DISPLAY_ACTION_CONFIRMATION: (state, payload) => {
      if (payload.shown) {
        state.actionConfirmationMessage = payload.message;
        state.showActionConfirmation = payload.shown;
      } else {
        state.showActionConfirmation = payload;
      }
    },
    GET_NOTIFICATIONS: (state, payload) => {
      state.notificationList = payload.payload;
    },
  },
};


export default notificationPanel